import React, { memo } from "react";
import s from "./style.module.scss";
import { IMainGift } from "./types";
import Bonuses from "shared/ui/Bonuses";
import { Link } from "react-router-dom";
import ImageLazy from "shared/ui/ImageLazy";

const MainGift: React.FC<IMainGift> = memo(
  ({ period_to, price, place_title, title, image, id, malls }) => {
    return (
      <li className={s.gift}>
        <Link to={`/gift/${id}`} />
        <div className={s.image}>
          <ImageLazy src={image} alt="Gift" />
        </div>

        {malls.length > 0 && (
          <ul className={s.malls}>
            <li className={s.item}>{malls[0].title}</li>
            {malls.length > 1 && (
              <li className={s.item}>и еще в {malls.length - 1}</li>
            )}
          </ul>
        )}

        <div className={s.content}>
          <h3>{title}</h3>
          <span>{place_title}</span>
          <div className={s.bottom}>
            <div className={s.date}>
              до {new Date(period_to).toLocaleDateString()}
            </div>
            <Bonuses count={price} />
          </div>
        </div>
      </li>
    );
  }
);

export default MainGift;
